module.exports = __webpack_public_path__ + "static/media/futureskill3.096e4052.png";